/**
 * ========================================
 * NOTIFICATION TYPES
 * ========================================
 * Domain types for the notification bell dropdown.
 * Fields match the backend NotificationDTO exactly (snake_case), per the
 * app's convention of not transforming shapes at the type-definition layer.
 */

export type NotificationPriority = 'low' | 'medium' | 'high' | 'urgent';

export interface AppNotification {
  id: string;
  source_type: string;
  source_id?: string | null;
  notification_type: string;
  title: string;
  message: string;
  action_url?: string | null;
  icon?: string | null;
  priority: NotificationPriority;
  is_viewed: boolean;
  viewed_at?: string | null;
  created_at?: string | null;
}

export const NOTIFICATION_PRIORITY_DOT: Record<NotificationPriority, string> = {
  low: 'bg-gray-400',
  medium: 'bg-blue-500',
  high: 'bg-orange-500',
  urgent: 'bg-red-500',
};
